import React from 'react';

import { useTable, useRowSelect, useSortBy, usePagination } from "react-table";

import {
  Flex,
  Table, Tbody, Td, Th, Thead, Tr,
  Text,
} from '@chakra-ui/react';

export const TableMembros = (props) => {
  const {
    data,
    columns
  } = props;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: 
          [
            {
              id: "nome",
              desc: false
            },
            {
              id: "nomeVoluntariado",
              desc: false
            }
          ]
        ,
        pageSize: data.length
      },
    },
    useSortBy,
    usePagination,
    useRowSelect,
  );

  return (
    <Flex flexDir='column' overflowX="auto">
      <Table {...getTableProps} mt="5px">
        <Thead backgroundColor="#ECEFF1">

          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
            {headerGroup.headers.map((column, index) => (
              <Th 
                {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                key={index}
              >
                <Flex 
                  flexDir="row" 
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Text as="p">
                    {column.render('Header')}
                  </Text>
                </Flex>
              </Th>
            ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps} bgColor="#FFF">
          {
            page.map((row, i) => {
              prepareRow(row)
              return (
                <Tr {...row.getRowProps()} key={i}>
                  {
                  row.cells.map((cell, index) => {
                    return (
                      <Td 
                        key={index}
                        {...cell.getCellProps()}
                        py="6px"
                        fontWeight={500}
                        fontSize="9px"
                        lineHeight="15px"
                        color="#797A80"
                      >
                          {cell.render('Cell')}
                      </Td>
                    )
                })}
                </Tr>
              )
            })
          }
        </Tbody>
      </Table>
    </Flex>
  )
}